import ga from '../utils/ga'

export const reportVideoProgress = (eventName: string, videoSrc: string) => {
  ga('send', 'event', 'video player - search', eventName, videoSrc)
}
